<template>
  <div>
    <a-form :form="form" @submit="updateParent">
      <a-divider orientation="left">{{ $t("liste.pere") }}</a-divider>
      <div class="row">
        <div class="col-md-4">
          <a-form-item :label="$t('liste.prenomPere')">
            <a-input
              v-decorator="[
                'parents.father.firstName',
                {
                  initialValue: parents.father
                    ? parents.father.firstName
                    : null,
                  rules: [
                    {
                      required: true,
                      message: this.$t('requis.prenomPere'),
                    },
                  ],
                },
              ]"
              :placeholder="$t('liste.prenomPere')"
            />
          </a-form-item>
        </div>
        <div class="col-md-4">
          <a-form-item :label="$t('liste.nomPere')">
            <a-input
              v-decorator="[
                'parents.father.lastName',
                {
                  initialValue: parents.father ? parents.father.lastName : null,
                  rules: [
                    {
                      required: true,
                      message: this.$t('requis.nomPere'),
                    },
                  ],
                },
              ]"
              :placeholder="$t('liste.nomPere')"
            />
          </a-form-item>
        </div>
        <div class="col-md-4">
          <a-form-item :label="$t('profil.middleName')">
            <a-input
              v-decorator="[
                'parents.father.middleName',
                {
                  initialValue: parents.father ? parents.father.middleName : null,
                  rules: [{ required: false }],
                },
              ]"
              :placeholder="$t('profil.middleName')"
            />
          </a-form-item>
        </div>
        <div class="col-md-4">
          <a-form-item :label="$t('liste.telPere')">
            <phone-number-input
              :default-country-code="countryCode === 'KE' ? 'KE' : 'TN'"
              v-decorator="[
                'parents.father.phone',
                {
                  initialValue: parents.father ? parents.father.phone : null,
                  rules: [{ required: false }],
                },
              ]"
            />
          </a-form-item>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4">
          <a-form-item :label="$t('liste.email')">
            <a-input
              v-decorator="[
                'parents.father.email',
                {
                  initialValue: parents.father ? parents.father.email : null,
                  rules: [
                    {
                      type: 'email',
                      message: $t('requis.email'),
                    },
                  ],
                },
              ]"
              :placeholder="$t('liste.email')"
            />
          </a-form-item>
        </div>
        <div class="col-md-4">
          <a-form-item :label="$t('liste.adresse')">
            <a-input
              v-decorator="[
                'parents.father.adress',
                {
                  initialValue: parents.father ? parents.father.adress : null,
                  rules: [
                    {
                      required: false,
                    },
                  ],
                },
              ]"
              :placeholder="$t('liste.adresseParents')"
            />
          </a-form-item>
        </div>
        <div class="col-md-4">
          <a-form-item :label="$t('liste.metierPere')">
            <a-input
              v-decorator="[
                'parents.father.job',
                {
                  initialValue: parents.father ? parents.father.job : null,
                  rules: [
                    {
                      required: false,
                    },
                  ],
                },
              ]"
              :placeholder="$t('liste.metierPere')"
            />
          </a-form-item>
        </div>
        <div class="col-md-4">
          <a-form-item :label="$t('liste.cinPere')">
            <a-input
              maxlength="8"
              v-decorator="[
                'parents.father.cin',
                {
                  initialValue: parents.father ? parents.father.cin : null,
                  rules: [
                    {
                      validator: (rule, value, cb) => {
                        if (!value || String(value).trim() === '') return cb();
                        if (!/^[01]\d{7}$/.test(String(value).trim())) return cb(this.$t('requis.cin01'));
                        cb();
                      },
                    },
                  ],
                },
              ]"
              :placeholder="$t('liste.cinPere')"
            />
          </a-form-item>
        </div>
      </div>
      <a-divider orientation="left">{{ $t("liste.mere") }}</a-divider>
      <div class="row">
        <div class="col-md-4">
          <a-form-item :label="$t('liste.prenomMere')">
            <a-input
              v-decorator="[
                'parents.mother.firstName',
                {
                  initialValue: parents.mother
                    ? parents.mother.firstName
                    : null,
                  rules: [
                    {
                      required: true,
                      message: this.$t('requis.prenomMere'),
                    },
                  ],
                },
              ]"
              :placeholder="$t('liste.prenomMere')"
            />
          </a-form-item>
        </div>
        <div class="col-md-4">
          <a-form-item :label="$t('liste.nomMere')">
            <a-input
              v-decorator="[
                'parents.mother.lastName',
                {
                  initialValue: parents.mother ? parents.mother.lastName : null,
                  rules: [
                    {
                      required: true,
                      message: this.$t('requis.nomMere'),
                    },
                  ],
                },
              ]"
              :placeholder="$t('liste.nomMere')"
            />
          </a-form-item>
        </div>
        <div class="col-md-4">
          <a-form-item :label="$t('profil.middleName')">
            <a-input
              v-decorator="[
                'parents.mother.middleName',
                {
                  initialValue: parents.mother ? parents.mother.middleName : null,
                  rules: [{ required: false }],
                },
              ]"
              :placeholder="$t('profil.middleName')"
            />
          </a-form-item>
        </div>
        <div class="col-md-4">
          <a-form-item :label="$t('liste.telMere')">
            <phone-number-input
              :default-country-code="countryCode === 'KE' ? 'KE' : 'TN'"
              v-decorator="[
                'parents.mother.phone',
                {
                  initialValue: parents.mother ? parents.mother.phone : null,
                  rules: [{ required: false }],
                },
              ]"
            />
          </a-form-item>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4">
          <a-form-item :label="$t('liste.email')">
            <a-input
              v-decorator="[
                'parents.mother.email',
                {
                  initialValue: parents.mother ? parents.mother.email : null,
                  rules: [
                    {
                      type: 'email',
                      message: $t('requis.email'),
                    },
                  ],
                },
              ]"
              :placeholder="$t('liste.email')"
            />
          </a-form-item>
        </div>
        <div class="col-md-4">
          <a-form-item :label="$t('liste.adresse')">
            <a-input
              v-decorator="[
                'parents.mother.adress',
                {
                  initialValue: parents.mother ? parents.mother.adress : null,
                  rules: [
                    {
                      required: false,
                    },
                  ],
                },
              ]"
              :placeholder="$t('liste.adresseParents')"
            />
          </a-form-item>
        </div>
        <div class="col-md-4">
          <a-form-item :label="$t('liste.metierMere')">
            <a-input
              v-decorator="[
                'parents.mother.job',
                {
                  initialValue: parents.mother ? parents.mother.job : null,
                  rules: [
                    {
                      required: false,
                    },
                  ],
                },
              ]"
              :placeholder="$t('liste.metierMere')"
            />
          </a-form-item>
        </div>
        <div class="col-md-4">
          <a-form-item :label="$t('liste.cinMere')">
            <a-input
              maxlength="8"
              v-decorator="[
                'parents.mother.cin',
                {
                  initialValue: parents.mother ? parents.mother.cin : null,
                  rules: [
                    {
                      validator: (rule, value, cb) => {
                        if (!value || String(value).trim() === '') return cb();
                        if (!/^[01]\d{7}$/.test(String(value).trim())) return cb(this.$t('requis.cin01'));
                        cb();
                      },
                    },
                  ],
                },
              ]"
              :placeholder="$t('liste.cinMere')"
            />
          </a-form-item>
        </div>
      </div>
      <a-divider orientation="left">{{ $t("liste.guardian") }}</a-divider>
      <div class="row">
        <div class="col-md-4">
          <a-form-item :label="$t('liste.gardianFirstName')">
            <a-input
              v-decorator="[
                'parents.guardian.firstName',
                {
                  initialValue: parents.guardian
                    ? parents.guardian.firstName
                    : null,
                  rules: [
                    {
                      required: false,
                    },
                  ],
                },
              ]"
              :placeholder="$t('liste.gardianFirstName')"
            />
          </a-form-item>
        </div>
        <div class="col-md-4">
          <a-form-item :label="$t('liste.gardianName')">
            <a-input
              v-decorator="[
                'parents.guardian.lastName',
                {
                  initialValue: parents.guardian
                    ? parents.guardian.lastName
                    : null,
                  rules: [
                    {
                      required: false,
                    },
                  ],
                },
              ]"
              :placeholder="$t('liste.gardianName')"
            />
          </a-form-item>
        </div>
        <div class="col-md-4">
          <a-form-item :label="$t('profil.middleName')">
            <a-input
              v-decorator="[
                'parents.guardian.middleName',
                {
                  initialValue: parents.guardian
                    ? parents.guardian.middleName
                    : null,
                  rules: [{ required: false }],
                },
              ]"
              :placeholder="$t('profil.middleName')"
            />
          </a-form-item>
        </div>
        <div class="col-md-4">
          <a-form-item :label="$t('liste.gardianPhone')">
            <phone-number-input
              :default-country-code="countryCode === 'KE' ? 'KE' : 'TN'"
              v-decorator="[
                'parents.guardian.phone',
                {
                  initialValue: parents.guardian
                    ? parents.guardian.phone
                    : null,
                  rules: [{ required: false }],
                },
              ]"
            />
          </a-form-item>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4">
          <a-form-item :label="$t('liste.email')">
            <a-input
              v-decorator="[
                'parents.guardian.email',
                {
                  initialValue: parents.guardian
                    ? parents.guardian.email
                    : null,
                  rules: [
                    {
                      type: 'email',
                      message: $t('requis.email'),
                    },
                  ],
                },
              ]"
              :placeholder="$t('liste.email')"
            />
          </a-form-item>
        </div>
        <div class="col-md-4">
          <a-form-item :label="$t('liste.gardianAdress')">
            <a-input
              v-decorator="[
                'parents.guardian.adress',
                {
                  initialValue: parents.guardian
                    ? parents.guardian.adress
                    : null,
                  rules: [
                    {
                      required: false,
                    },
                  ],
                },
              ]"
              :placeholder="$t('liste.gardianAdress')"
            />
          </a-form-item>
        </div>
        <div class="col-md-4">
          <a-form-item :label="$t('liste.gardianJob')">
            <a-input
              v-decorator="[
                'parents.guardian.job',
                {
                  initialValue: parents.guardian ? parents.guardian.job : null,
                  rules: [
                    {
                      required: false,
                    },
                  ],
                },
              ]"
              :placeholder="$t('liste.gardianJob')"
            />
          </a-form-item>
        </div>
        <div class="col-md-4">
          <a-form-item :label="$t('liste.cinGardian')">
            <a-input
              maxlength="8"
              v-decorator="[
                'parents.guardian.cin',
                {
                  initialValue: parents.guardian ? parents.guardian.cin : null,
                  rules: [
                    {
                      validator: (rule, value, cb) => {
                        if (!value || String(value).trim() === '') return cb();
                        if (!/^[01]\d{7}$/.test(String(value).trim())) return cb(this.$t('requis.cin01'));
                        cb();
                      },
                    },
                  ],
                },
              ]"
              :placeholder="$t('liste.cinGardian')"
            />
          </a-form-item>
        </div>
      </div>
      <a-divider orientation="left">{{ $t("liste.enfants") }}</a-divider>
      <div class="row">
        <div class="col-md-4">
          <a-form-item :label="$t('liste.nombreEnfants')">
            <a-input
              type="number"
              v-decorator="[
                'parents.numberOfChildren',
                {
                  initialValue: parents.numberOfChildren,
                },
              ]"
              :placeholder="$t('liste.nombreEnfants')"
            />
          </a-form-item>
        </div>
        <div class="col-md-4">
          <a-form-item :label="$t('liste.situationFamiliale')">
            <a-input
              v-decorator="[
                'parents.financialStatus',
                {
                  initialValue: parents.financialStatus,
                  rules: [
                    {
                      required: false,
                    },
                  ],
                },
              ]"
              :placeholder="$t('liste.situationFamiliale')"
            />
          </a-form-item>
        </div>
      </div>
      <br />
      <div class="row justify-content-center border-with-text mx-2 mb-2">
        <span class="border-text">{{ $t("menu.liste") }} </span>
        <a-list
          :grid="{
            gutter: childreen.length > 4 ? 12 : 24,
            column: childreen.length > 4 ? 4 : childreen.length,
          }"
          item-layout="v"
          :data-source="childreen"
          :bordered="false"
        >
          <a-list-item slot="renderItem" slot-scope="item, index">
            <a-list-item-meta
              @click="() => openProfile(item.id)"
              :description="item.description"
            >
              <a slot="title" :class="index">{{ item.title }}</a>
              <a-avatar
                size="large"
                slot="avatar"
                v-if="item.photo"
                :src="settings.resourcesUrl.replace('FILE_PATH', item.photo)"
              />
              <a-avatar
                size="large"
                slot="avatar"
                style="color: #f56a00; background-color: #fde3cf"
                v-else
              >
                {{ item.title[0].toUpperCase() }}
              </a-avatar>
            </a-list-item-meta>
          </a-list-item>
        </a-list>
      </div>
      <div class="row mt-1">
        <div class="col d-flex justify-content-end">
          <a-button
            key="submit"
            type="primary"
            :loading="loadingData"
            :disabled="loadingData"
            htmlType="submit"
          >
            {{ $t("action.enregistrer") }}
          </a-button>
        </div>
      </div>
    </a-form>
  </div>
</template>
<script>
import { mapState } from "vuex";
import apiClient from "@/services/axios";
import { notification } from "ant-design-vue";
import router from "@/router";
function flattenToDotNotation(obj, prefix = "") {
  const result = {};

  for (const [key, value] of Object.entries(obj)) {
    const fullKey = prefix ? `${prefix}.${key}` : key;

    if (value !== null && typeof value === "object" && !Array.isArray(value)) {
      Object.assign(result, flattenToDotNotation(value, fullKey));
    } else {
      result[fullKey] = value;
    }
  }

  return result;
}

export default {
  props: {
    parentID: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      form: this.$form.createForm(this),
      loadingData: false,
      parents: {
        father: {
          firstName: "",
          lastName: "",
        },
        mother: {
          firstName: "",
          lastName: "",
        },
        students: [],
        _id: "",
        photo: "",
      },
    };
  },
  computed: {
    ...mapState(["settings", "user"]),
    countryCode() {
      const activeBuilding =
        this.user.building.find(
          (el) => el.dbName == this.settings.activeBuilding
        ) || {};
      return activeBuilding.countryCode || "TN";
    },
    childreen: function () {
      return this.parents.students.map((child) => ({
        id: child._id,
        photo: child.photo,
        title:
          child.firstName +
          (child.middleName ? " " + child.middleName : "") +
          " " +
          child.lastName,
      }));
    },
  },
  async created() {
    await this.fetchParentData();
  },
  methods: {
    openNotificationWithIcon(type, msg, desc) {
      notification[type]({
        message: msg,
        description: desc,
      });
    },
    openProfile(id) {
      router
        .push(`/eleve/${id}`)
        .then(() => {
          window.location.reload();
        })
        .catch((error) => {
          console.info(error);
        });
    },
    updateParent(e) {
      e.preventDefault();
      this.form.validateFieldsAndScroll(async (err, values) => {
        if (!err) {
          const data = values.parents;
          const parentList = ["father", "mother", "guardian"];
          const keyList = [
            "firstName",
            "middleName",
            "lastName",
            "phone",
            "email",
            "adress",
            "job",
            "cin",
          ];
          // ! important to keep the original data of the parent
          parentList.forEach((parent) => {
            if (data[parent]) {
              keyList.forEach((key) => {
                if (data[parent][key]) {
                  data[parent][key] = data[parent][key];
                }
              });
              data[parent] = _.merge({}, this.parents[parent], data[parent]);
            }
          });
          apiClient
            .patch(`/parents/${this.parentID}`, { data })
            .then((res) => {
              this.$message.success(this.$t("success.parentMSA"));
              this.$emit("parentUpdated", { ...data, id: this.parentID });
            })
            .catch((e) =>
              this.openNotificationWithIcon(
                "warning",
                this.$t("changementNonEffectue"),
                this.$t("champsVides")
              )
            );
        }
      });
    },
    async fetchParentData() {
      try {
        this.loadingData = true;
        const res = await apiClient.post("/parents/filter", {
          query: { _id: this.parentID },
          aggregation: [
            {
              $lookup: {
                from: "students",
                localField: "students",
                foreignField: "_id",
                as: "students",
              },
            },
            {
              $project: {
                father: 1,
                mother: 1,
                guardian: 1,
                students: 1,
                adress: 1,
                numberOfChildren: 1,
                financialStatus: 1,
                _id: 1,
                photo: 1,
                email: 1,
              },
            },
          ],
        });
        this.parents = res.data[0];
      } catch {
        this.$message.error("Could not find parent");
      } finally {
        this.loadingData = false;
      }
    },
  },
};
</script>
<style scoped>
.border-with-text {
  position: relative;
  border: 2px solid #95a3b3;
  padding: 1rem;
}

.border-with-text .border-text {
  position: absolute;
  top: -12px;
  left: 20px;
  background-color: white;
  padding: 0 10px;
  font-weight: bold;
}
</style>
